import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';

type Group = { id: string; name: string; members: number; lessons: number };

export default function AdminGroups() {
    const [groups, setGroups] = useState<Group[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const api = new ApiHelper();

    useEffect(() => { load(); }, []);

    async function load() {
        try { setGroups(await (await api.adminGroupsApi.list()).json()); } catch (x: any) { api.adminError(x); } finally { setLoaded(true); }
    }
    async function create() {
        if (!name.trim()) return;
        try { const r = await (await api.adminGroupsApi.create({ name: name.trim() })).json(); setName(""); navigate("/admin/skupiny/" + r.id); } catch (x: any) { api.adminError(x); }
    }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Skupiny</h1><p>Ročníkové skupiny, členové a online lekce</p></div>
            </div>

            <div className="searchBar" style={{ maxWidth: "460px" }}>
                <input placeholder="Název nové skupiny…" value={name} onChange={e => setName(e.target.value)} onKeyDown={e => e.key === "Enter" && create()} />
                <button className="aBtn" disabled={!name.trim()} onClick={create}>+ Vytvořit</button>
            </div>

            <table className="aTable">
                <thead><tr><th>Název</th><th>Členů</th><th>Online lekcí</th></tr></thead>
                <tbody>
                    {groups.map(g => (
                        <tr key={g.id} onClick={() => navigate("/admin/skupiny/" + g.id)}>
                            <td>{g.name || <span className="muted">(bez názvu)</span>}</td>
                            <td>{g.members}</td>
                            <td>{g.lessons}</td>
                        </tr>
                    ))}
                    {loaded && groups.length === 0 && <tr><td colSpan={3} className="muted">Žádné skupiny.</td></tr>}
                </tbody>
            </table>
        </div>
    );
}
